import { Table2 } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import ToolPage from "./ToolPage";

export default function ExcelToPDF() {
  const { t } = useLanguage();
  const tk = t.tools.excelToPdf;

  const config = {
    title: tk.title,
    description: tk.description,
    action: tk.action,
    hint: tk.dropHint,
    hintSub: tk.dropHintSub,
    endpoint: "/excel/excel-to-pdf",
    accept: ".xlsx",
    multiple: false,
    resultType: "download",
    resultFileName: tk.result,
    color: "#15803d",
    Icon: Table2,
    toolKey: "excelToPdf",
  };

  return <ToolPage config={config} />;
}
